export default __webpack_public_path__ + "static/media/Bayonet Combat.6bcc43f2.png";